
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"10","height":"10","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M5 1a.8.8 0 01.8.8v2.4h2.4a.8.8 0 110 1.6H5.8v2.4a.8.8 0 11-1.6 0V5.8H1.8a.8.8 0 110-1.6h2.4V1.8A.8.8 0 015 1z","fill":"#008C89"}})])
          )
        }
      }
    